import '../../app.es6';
import angular from 'angular';

const NOTIFICATION_PERMISSION_NOT_NOTIFIED = 0;
const NOTIFICATION_PERMISSION_BE_NOTIFIED = 1;

class NotificationConfigrationController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location, $window, $timeout,
    commonAuthFactory, commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.$window = $window;
    this.$timeout = $timeout;
    this.commonAuthFactory = commonAuthFactory;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    this.notificationPermission = false; // ビデオ通知許可

    Page.setTitle(this.Const.TITLE.notificationConfigration);

    this.setNotificationConfigration();

    NotificationConfigrationController.$inject = [
      '$scope', '$sessionStorage', '$location', '$window', '$timeout',
      'commonAuthFactory', 'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }
  setNotificationConfigration () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    this.commonApiFactory.getMembersMe()
    .then((member) => {
      // data.notificationPermisisonが未設定の場合は通知許可
      this.notificationPermission =
        member.data.notificationPermission === undefined || member.data.notificationPermission === NOTIFICATION_PERMISSION_BE_NOTIFIED;
      if (this.notificationPermission) {
        document.getElementById('notification-permission').setAttribute('checked', 'checked');
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  submit () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    this.notificationPermission =
      document.getElementById('notification-permission').checked ? NOTIFICATION_PERMISSION_BE_NOTIFIED : NOTIFICATION_PERMISSION_NOT_NOTIFIED;
    let memberMeParams = { data: { notificationPermission: this.notificationPermission } };
    this.commonApiFactory.putMembersMe(memberMeParams).then((member) => {
      this.$timeout(() => {
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
        this.$window.history.back();
      }, 1500);
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  cancel () {
    this.$window.history.back();
  }
}
angular.module('myApp')
  .controller('NotificationConfigrationController', NotificationConfigrationController);



// WEBPACK FOOTER //
// ./app/components/notification-configration/notification-configration-controller.es6